import { z } from "zod";
import type { CategoryPlugin } from "../plugin";

const schema = z.object({
  volume_ml: z.number().positive().optional(),
  purity: z.enum(["Pure Attar","Blended Oil","Dilution"]).optional(),
  origin: z.string().optional(),
});

export const plugin: CategoryPlugin<z.infer<typeof schema>> = {
  metadata: {
    id: "perfume-oils", slug: "perfume-oils", name: "Perfume Oils",
    tagline: "Pure attar and blended oils", status: "launched",
  },
  attributeSchema: schema,
  search: { columns: ["name","family","notes"], attributes: ["origin"] },
  facets: [
    { key: "family", label: "Family", type: "enum", source: "column",
      options: ["Floral","Oriental","Woody","Amber"] },
    { key: "purity", label: "Purity", type: "enum", source: "attribute",
      options: ["Pure Attar","Blended Oil","Dilution"] },
    { key: "volume_ml", label: "Volume (ml)", type: "range", source: "attribute",
      min: 3, max: 100, step: 1, unit: "ml" },
    { key: "price", label: "Price (₹)", type: "range", source: "column",
      min: 30, max: 600, step: 10, unit: "₹" },
  ],
  pdpPanels: [
    { key: "product", label: "Oil details", attributes: ["volume_ml","purity","origin"] },
  ],
  seo: {
    titleTemplate: "{name} · CB16 Perfume Oil",
    descriptionTemplate: "{name} — alcohol-free perfume oil.",
    routePrefix: "perfume-oils",
  },
  adminForm: [
    { key: "volume_ml", label: "Volume (ml)", kind: "number" },
    { key: "purity", label: "Purity", kind: "select", options: ["Pure Attar","Blended Oil","Dilution"] },
    { key: "origin", label: "Origin", kind: "text" },
  ],
};
